import { Link } from "react-router-dom";

export const BrandWord = ({ className = "" }) => (
  <span className={`font-display font-extrabold tracking-tight ${className}`} data-testid="brand-word">
    <span className="text-[#F4F6F8]">BKM</span><span className="text-[#F5A30A]">PLAY</span>
  </span>
);

export const Logo = ({ to = "/", tagline = true }) => (
  <Link to={to} className="flex flex-col leading-none" data-testid="header-logo">
    <BrandWord className="text-xl" />
    {tagline && <span className="mt-1 whitespace-nowrap text-[9px] font-semibold uppercase tracking-[0.16em] text-slate-400 sm:text-[10px] sm:tracking-[0.22em]" data-testid="brand-tagline">Dés · Ludo · Dames</span>}
  </Link>
);
